import {Component,Input,} from '@angular/core';
import {CarouselModule, OwlOptions} from "ngx-owl-carousel-o";
import {NgClass, NgForOf, SlicePipe} from "@angular/common";
import {Carousel} from "../../../../app/core/interface/carousel";

@Component({
  selector: 'carousel',
  imports: [
    CarouselModule,
    NgForOf,
    SlicePipe,
    NgClass
  ],
  standalone: true,
  templateUrl: './carousel.component.html',
  styleUrl: './carousel.component.scss'
})
export class CarouselComponent {
  @Input() customOptions!: OwlOptions
  @Input() carouselInfo: Carousel[] | undefined
  activeIndex = 0;
  currentIndex: number = 0;


  setActiveIndex(index: number) {
    this.activeIndex = index;
  }


  onCarouselChange(event: any): void {
    this.currentIndex = Math.floor( event.startPosition / 3) * 3;
    this.activeIndex =  event.startPosition;
  }

}
